<script lang="ts">
    import { onMount } from 'svelte';
    import Messe from './Messe.svelte';
    let tage = [];

    onMount(async () => {
        let response = await fetch('https://beichte.medienschaffer.de/');
        let alleMessen = await response.json();

        var groupBy = (xs, key) => {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };
        tage = Object.values(groupBy(alleMessen, 'TE_Datum'));
    });
</script>

<svelte:head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta
        name="viewport"
        content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"
    />
    <meta name="description" content="Messen in Neuss" />
    <title>Messen in Neuss</title>
    <meta name="full-screen" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-title" content="Messen in Neuss" />
    <meta
        name="apple-mobile-web-app-status-bar-style"
        content="black-translucent"
    />
</svelte:head>

<main>
    <h1>⛪️</h1>
    {#each tage as messen}
        <details>
            <summary>
                {new Date(messen[0].TE_Datum).toLocaleDateString('de-DE', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                })}
            </summary>
            {#each messen as messe}
                <Messe {messe} />
            {/each}
        </details>
        {#if new Date(messen[0].TE_Datum).getUTCDay() == 6}
            <div class="h-10" />
        {/if}
    {/each}
</main>

<style global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    body {
        @apply p-0 bg-sky-50;
    }

    main {
        @apply max-w-screen-md mx-auto p-2 space-y-2;
    }

    h1 {
        @apply text-center my-6 text-8xl font-bold;
    }

    details {
        @apply border shadow-sm rounded bg-white divide-y;
    }

    details[open] {
        @apply bg-sky-300;
    }

    summary {
        @apply cursor-pointer text-lg py-4 px-2 font-medium;
    }
</style>
